import axios from "axios";

// Set base URL for API calls
const baseURL = process.env.API_BASE_URL || "https://api.healthytantra.aaibuzz.com/api";
// const baseURL = "http://127.0.0.1:8001/api";
axios.defaults.baseURL = baseURL;

// Export media URL for use in components
export const mediaURL = process.env.MEDIA_URL || "https://blr1.vultrobjects.com/space-1/";
// export const mediaURL = "https://blr1.vultrobjects.com/space-1/";

// Function to setup interceptors after store is available
export function setupInterceptors(store) {
    // Request interceptor to add auth token and company context
    axios.interceptors.request.use(
        (config) => {
            // Clear previous errors
            if (store) {
                store.dispatch("errors/setErrors", {});
                store.dispatch("errors/setStatus", null);
            }

            // Add auth token if available
            const token = localStorage.getItem("token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            // Add company context if available
            if (store) {
                const company = store.getters["auth/company"];
                if (company && company.id) {
                    config.headers["company-id"] = company.id;
                }
            }

            // The admin panel always receives the full payload from the API.
            // Mobile apps (which don't go through this axios instance) get the
            // slim payload by default. Auto-attach ?context=panel to EVERY
            // request (GET/POST/PATCH/PUT/DELETE) so individual call sites
            // don't have to — but ONLY if the caller hasn't already set a
            // `context` param (some endpoints, like /masters, use
            // `context=user|seller|...` for their own dispatch logic and must
            // not be overwritten). Also skip if the URL itself already has
            // `context=` in its query string.
            const hasParamContext =
                config.params &&
                Object.prototype.hasOwnProperty.call(config.params, 'context') &&
                config.params.context !== undefined &&
                config.params.context !== null &&
                config.params.context !== '';
            const hasUrlContext =
                typeof config.url === 'string' && /[?&]context=/.test(config.url);

            if (!hasParamContext && !hasUrlContext) {
                config.params = { ...(config.params || {}), context: 'panel' };
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Response interceptor to handle errors globally
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // Handle authentication errors
            if (error.response && error.response.status === 401) {
                if (store) {
                    store.dispatch("auth/logOut");
                }
                localStorage.removeItem("token");
                localStorage.removeItem("company");
                window.location.href = "/login";
            }

            // Handle validation errors
            if (error.response && error.response.data && error.response.data.errors) {
                const errors = error.response.data.errors;
                Object.keys(errors).forEach((key) => {
                    errors[key] = errors[key][0];
                });
                if (store) {
                    store.dispatch("errors/setErrors", errors);
                }
            }

            // Set error status
            if (error.response && store) {
                store.dispatch("errors/setStatus", error.response.status);
            }

            return Promise.reject(error);
        }
    );

    // Set initial URLs in store
    if (store) {
        store.dispatch("settings/setBaseUrl", baseURL);
        store.dispatch("settings/setMediaUrl", mediaURL);
    }
}

export default axios;
